import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Navigation from '../Navigation/Navigation'
import MobileMenu from '../Navigation/MobileMenu'
import ThemeToggle from '../ThemeToggle/ThemeToggle'
import styles from './Header.module.css'

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location])

  return (
    <>
      <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
        <div className={styles.container}>
          <a
            href="#hero"
            className={styles.logo}
            onClick={(e) => {
              e.preventDefault()
              if (location.pathname !== '/') {
                window.location.href = '/#hero'
                return
              }
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              })
            }}
          >
            <span className={styles.logoIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line></svg>
            </span>
            <span className={styles.logoName}>Inon Baguio</span>
          </a>

          <Navigation className={styles.desktopNav} />

          <div className={styles.headerActions}>
            <ThemeToggle />
            <button
            className={styles.mobileMenuButton}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <span className={`${styles.hamburger} ${isMobileMenuOpen ? styles.active : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          </div>
        </div>
      </header>

      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </>
  )
}

export default Header